import { render, staticRenderFns } from "./OpportunitiesPanel.vue?vue&type=template&id=6ea5e538&scoped=true&"
import script from "./OpportunitiesPanel.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesPanel.vue?vue&type=style&index=0&id=6ea5e538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea5e538",
  null
  
)

export default component.exports